// Header names for forwarding geolocation to the API (match server GEO_HEADERS).
export const GEO_HEADERS = {
	CITY: "x-geo-city",
	COUNTRY: "x-geo-country",
	REGION: "x-geo-region",
	LATITUDE: "x-geo-latitude",
	LONGITUDE: "x-geo-longitude"
};

// Builds the x-geo-* request headers from a user geolocation object. Returns an
// empty object when geolocation is absent so we never send literal "undefined"
// header values to the gateway.
export default function buildGeoHeaders(geolocation) {
	if (!geolocation) return {};
	return {
		[GEO_HEADERS.CITY]: String(geolocation.city),
		[GEO_HEADERS.COUNTRY]: String(geolocation.country),
		[GEO_HEADERS.REGION]: String(geolocation.region),
		[GEO_HEADERS.LATITUDE]: String(geolocation.latitude),
		[GEO_HEADERS.LONGITUDE]: String(geolocation.longitude)
	};
}
